module.exports = "/_next/static/images/lunchsoup-872d67686b4d74873e3a676e5750b65a.jpg";